// extracted by mini-css-extract-plugin
export default {"form":"secondary-market_form__yqf2S","row":"secondary-market_row__m6MCH","actions":"secondary-market_actions__pUjgT","saveButton":"secondary-market_saveButton__FdnBw"};